/**
 * Format a past timestamp as "à l'instant", "il y a N min", "il y a N h", or fallback to HH:mm.
 * No external dependency.
 */
export const formatRelative = (ts: number | { seconds: number; nanoseconds: number } | undefined): string => {
  if (!ts) return "";
  const ms = typeof ts === "number" ? ts : ts.seconds * 1000 + Math.floor(ts.nanoseconds / 1e6);
  if (!ms) return "";

  const diffSec = Math.floor((Date.now() - ms) / 1000);
  if (diffSec < 30) return "à l'instant";
  if (diffSec < 60) return `il y a ${diffSec} s`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `il y a ${diffMin} min`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 6) return `il y a ${diffH} h`;
  // Fallback: HH:mm in user's locale
  return new Date(ms).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};
